export default {"src":"/_next/static/media/beardo.31655b49.svg","height":99,"width":251,"blurWidth":0,"blurHeight":0};